import { get } from "./index";

export const getAllTransectionsAPI = (params) => {
  const request = {
    subUrl: `/transaction`,
    params,
  };
  return get(request);
};
